// src/components/ThankYouAnimation.js
//eslint-disable-next-line no-unused-vars
import { colors } from "material-ui/styles";
//eslint-disable-next-line no-unused-vars
import { white } from "material-ui/styles/colors";
import React, { useEffect, useState } from "react";

const THANK_YOU_WORDS = {
    "Köszönöm": { left: 16, top: 41, size: 9, angle: 0, delay: 0.2, direction: "forward", color: "#FFB3BA" },
    "Thank you": { left: 21, top: 22, size: 6, angle: 90, delay: 1, direction: "forward", color: "#FFDFBA" },
    "Gracias": { left: 41, top: 63, size: 6, angle: 90, delay: 1, direction: "backward", color: "#FFFFBA" },
    "Merci": { left: 30, top: 55, size: 5, angle: 0, delay: 2, direction: "forward", color: "#BAFFC9" },
    "Danke": { left: 49, top: 34, size: 5, angle: 0, delay: 3, direction: "backward", color: "#BAE1FF" },
    "谢谢": { left: 30, top: 64, size: 5, angle: 0, delay: 3, direction: "forward", color: "#D7BAFF" },
    "Grazie": { left: 12, top: 60, size: 5, angle: 90, delay: 4, direction: "backward", color: "#FFBAED" },
    "شكرا": { left: 3, top: 60, size: 5, angle: 90, delay: 5, direction: "backward", color: "#BAFFEF" },
    "ありがとう": { left: 55, top: 24, size: 5, angle: 90, delay: 6, direction: "forward", color: "#FFD2BA" },
    "감사합니다": { left: 8, top: 23, size: 5, angle: 90, delay: 4, direction: "forward", color: "#BAFFD9" },
    "Спасибо": { left: 50, top: 29, size: 3, angle: 0, delay: 4, direction: "backward", color: "#E2BAFF" },
    "Obrigado": { left: 44, top: 16, size: 4, angle: 90, delay: 4, direction: "forward", color: "#FFBACA" },
    "תודה": { left: 57, top: 15, size: 5, angle: 90, delay: 4, direction: "forward", color: "#BAFFFA" },
    "ขอบคุณ": { left: 65, top: 55, size: 5, angle: 0, delay: 4, direction: "backward", color: "#FFD7BA" },
    "Terima kasih": { left: 65, top: 65, size: 3, angle: 0, delay: 5, direction: "backward", color: "#BAE7FF" },
    "Tack": { left: 5, top: 46, size: 4, angle: 90, delay: 6, direction: "forward", color: "#E0FFBA" },
    "Mulțumesc": { left: -4, top: 23, size: 5, angle: 90, delay: 7, direction: "forward", color: "#FFBAF2" },
    "Děkuji": { left: 65, top: 71, size: 5, angle: 0, delay: 8, direction: "backward", color: "#BAFFEC" },
    "Chokran": { left: 12, top: 72, size: 6, angle: 0, delay: 8, direction: "forward", color: "#FFE1BA" }
};


export default function ThankYouAnimation({ onFinish }) {
    //const [show, setShow] = useState(true);
    /*
    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(false);
            if (typeof onFinish === "function") onFinish();
        }, 5000); // duration of animation
        return () => clearTimeout(timer);
    }, [onFinish]);*/

    //if (!show) return null;

    return (
        <div style={styles.overlay}>
            {Object.keys(THANK_YOU_WORDS).map((word, i) => {
                const props = THANK_YOU_WORDS[word];
                const size = props.size;
                const rotate = props.angle;
                const delay = props.delay;
                const left = props.left;
                const top = props.top;
                const direction = props.direction;
                const color = props.color;
                return (
                    <div
                        key={i}
                        style={{
                            ...styles.word,
                            fontSize: `${size}vw`,
                            transform: `rotate(${rotate}deg)`,
                            left: `${left}%`,
                            top: `${top}%`,
                            animation: `slideIn${rotate}${direction} 1s forwards`,
                            animationDelay: `${delay / 2}s`,
                            color: `${color}`,
                        }}
                    >
                        {word}
                    </div>
                );
            })}
        </div>
    );
}

const styles = {
    overlay: {
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#D21C3A",
        overflow: "hidden",
        zIndex: 9999,
    },
    word: {
        position: "absolute",
        color: "white !important",
        fontWeight: "bold",
        opacity: 0,
        color: "white",
        whiteSpace: "nowrap",
    },
    fullScreen: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        color: "white",
        fontSize: "5rem",
        fontWeight: "900",
        opacity: 0,
        animation: "fadeIn 1s 3s forwards", // fade in after other words
        color: "white",
    },
};

// Add the animations in your CSS
/* 
@keyframes slideIn {
  0% { transform: translateX(-200%) rotate(var(--rotate)); opacity: 0; }
  70% { opacity: 1; }
  100% { transform: translateX(0) rotate(var(--rotate)); opacity: 1; }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
*/
